import { normalizeNumber } from '@loggi/js/formatters';
import cep from '@loggi/js/formatters/cep';
import Button from '@loggi/ui/components/button';
import { SQUARE_SHAPE } from '@loggi/ui/components/button/types';
import Col from '@loggi/ui/components/col';
import DisplayInfo from '@loggi/ui/components/display-info';
import Text, { TEXT_TYPE_TITLE } from '@loggi/ui/components/text';
import TextInput from '@loggi/ui/components/text-input';
import colors from '@loggi/ui/components/utils/colors';
import View from '@loggi/ui/components/view';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { fetchQuery, graphql } from 'react-relay';
import environment from 'shared/relay/environment';
import { IS_PACKAGE_TRACKING_COMPLEMENT_FORM } from 'tracker.constants';
import { PATH_PACKAGE_TRACKING } from 'tracker.routes';

const query = graphql`
  query zipCodeQuery(
    $trackingKey: String!
    $postalCode: String
    $companySecretId: String
  ) {
    packageTracker(
      trackingKey: $trackingKey
      postalCode: $postalCode
      companySecretId: $companySecretId
    ) {
      packageInfo {
        companyHash
      }
    }
  }
`;

export default class PackageTrackingZipCode extends React.Component {
  static displayName = 'PackageTrackingZipCode';

  static propTypes = {
    match: PropTypes.shape({
      params: {
        trackingKey: PropTypes.string.isRequired
      }
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  };

  constructor(props) {
    super(props);
    this._onClick = this._onClick.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
    this._onKeyPress = this._onKeyPress.bind(this);

    this.state = {
      inputValue: '',
      error: false,
      trackingKey: props.match.params.trackingKey
    };
  }

  _onClick(callFetchQuery) {
    const { inputValue } = this.state;
    const postalCode = normalizeNumber(inputValue);
    const { trackingKey } = this.state;
    return callFetchQuery(environment, query, { trackingKey, postalCode })
      .then(response => {
        const companyHash = get(
          response,
          'packageTracker.packageInfo.companyHash',
          false
        );
        if (companyHash) {
          const { history } = this.props;
          return history.push(
            `${PATH_PACKAGE_TRACKING}/${companyHash}/${trackingKey}`
          );
        }

        return this.setState({
          error: true
        });
      })
      .catch(() => {
        return this.setState({
          error: true
        });
      });
  }

  _handleInputChange(e) {
    const valueWithoutWhitespace = e.target.value.trim();
    return this.setState({
      inputValue: cep(valueWithoutWhitespace),
      error: false
    });
  }

  _onKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this._onClick(fetchQuery);
    }
  }

  render() {
    const { error, trackingKey, inputValue } = this.state;
    const updateForm = IS_PACKAGE_TRACKING_COMPLEMENT_FORM;
    const inputErrorText = error ? updateForm.input.errorMessage : '';
    const inputStatus = error ? 'danger' : null;

    return (
      <Col
        size={12}
        gutter={{
          xs: { top: 'triple' },
          md: { bottom: 'triple' },
          xxl: { left: 'double' }
        }}
        className="package-wrapper"
      >
        <Col
          flex
          flexDirection="column"
          size={{ md: 6, lg: 6, xl: 5, xxl: 4 }}
          gutter={{
            xs: {
              top: 'triple',
              left: 'triple',
              right: 'triple',
              bottom: 'triple'
            },
            sm: { top: 'double' }
          }}
          className="main-content"
          backgroundColor={colors.type.WHITE}
        >
          <Text type={TEXT_TYPE_TITLE}>{updateForm.title}</Text>
          <Col size={updateForm.subtitle.size}>
            <View gutter={{ bottom: 'normal' }}>
              <Text type={TEXT_TYPE_TITLE}>{updateForm.subtitle.text}</Text>
            </View>
            <Col gutter={{ xs: { bottom: 'half' }, md: { bottom: 0 } }}>
              <DisplayInfo
                label={updateForm.displayInfoLabel}
                text={trackingKey}
              />
            </Col>
          </Col>
          <Col flexDirection="column" alignItems="center">
            <Col size={12} gutter={{ bottom: 'onehalf' }}>
              <TextInput
                value={inputValue}
                label={updateForm.input.label}
                placeholder={updateForm.input.placeholder}
                status={inputStatus}
                statusText={inputErrorText}
                inputProps={{
                  maxLength: 9,
                  onChange: this._handleInputChange,
                  onKeyPress: this._onKeyPress
                }}
              />
            </Col>
            <Col size={{ xs: 12, md: 7, lg: 6, xl: 6, xxl: 6 }}>
              <Button
                block
                value={updateForm.buttonValue}
                onClick={() => this._onClick(fetchQuery)}
                shape={SQUARE_SHAPE}
              />
            </Col>
          </Col>
        </Col>
      </Col>
    );
  }
}
